module.exports = __webpack_public_path__ + "static/horizontal-step-3-fc5f4cce7f798ab32111a621864b9a82.png";